<template>
  <div class="mySampleReturnClass">
111
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.mySampleReturnClass{
    width: 1200px;
}
</style>>